import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { BannerSlider } from '../../models/BannerSlider/BannerSlider-model';
import { BannerSliderService } from '../../services/BannerSlider/BannerSlider.service';
import { User } from '../../models/user/user-model';
import { Brand } from '../../models/Brand/brand-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from '../../services/user/user.service';
import { BrandService } from '../../services/brand/brand.service';
import { HttpEventType } from '@angular/common/http';
import { Http, Response, Headers } from '@angular/http';
import { CategoryService } from '../../services/category/category.service';
import { Category } from '../../models/category/category.model';
import { forEach } from '@angular/router/src/utils/collection';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';

import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-edit-BannerSlider',
  templateUrl: './edit-BannerSlider.component.html',
  styleUrls: ['./edit-BannerSlider.component.css']
})
/** create-notification component*/
export class EditBannerSliderComponent {
  public bannerSlider = new BannerSlider();

  count: number;
  public sortValue: any;
  public url: any;
  public deleteValue: any;
  public users: User[];
  public brands: Brand[];
  public categories: Category[];
  bannerSliderID: number;
  isDisable = true;
  files: any = [];
  i: number;
  urls = new Array<string>();
  serverFile = new Array<string>();
  public progress: number;
  public message: string;
  userId: number;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  banner: boolean = false;
  //public bellIcon: any;
  //public notificationTypes: string[];
  //public startDateElement: any;
  //public endDateElement: any;
  /** create-notification ctor */
  //constructor(private modalService: BsModalService, private readonly brandService: BrandService, public toastr: ToastsManager, ) {
  //  this.toastr.setRootViewContainerRef(vcr);
  //  if (this._avRoute.snapshot.params["id"]) {
  //    this.getbrandById(this._avRoute.snapshot.params["id"]);
  //  }
  //}
  constructor(private http: Http, private _avRoute: ActivatedRoute,
    private readonly brandService: BrandService,
    private readonly userService: UserService,
    private readonly categoryService: CategoryService,
    private readonly bannerSliderService: BannerSliderService,
    public toastr: ToastsManager, private readonly router: Router,
    private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService,
    private modalService: BsModalService,
    private cookieService: CookieService,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("bannerslider").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            if (this._avRoute.snapshot.params["id"]) {

              this.getBannerSliderById(this._avRoute.snapshot.params["id"]);

              setTimeout(() => {
                this.Getvenders();
                this.Getbrands();
                this.Getcategories();
              }, 0);
              this.bannerSlider.Id = this._avRoute.snapshot.params["id"];
            }
            //this.bannerSlider.brandID = 0;
            //this.bannerSlider.venderID = 0;
            //this.bannerSlider.type = "";
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {

                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this.router.navigate(["/BannerSlider-list"]);
          }
        }
        else {
          this.router.navigate(["/BannerSlider-list"]);
        }
      }
    )

  }
  getBannerSliderById(id: string) {
    this.bannerSliderService.getBannerSliderById(id).subscribe(
      data => {
        this.i = 0;
        this.urls = [];
        this.serverFile = [];
        this.bannerSlider.sliderFor = data.sliderFor;
        this.bannerSlider.webMobile = data.webMobile;
        this.bannerSlider.categoryID = data.categoryID;
        this.bannerSlider.isActive = data.isActive;
        this.bannerSlider.type = data.type;
        this.bannerSlider.brandID = data.brandID;
        this.bannerSlider.bannerSliderID = data.bannerSliderID;
        let stringToSplit = data.sort;
        this.bannerSlider.BannerSliderImages = data.bannerSliderImages;
        if (this.bannerSlider.sliderFor == 'Brand')
          this.banner = true;
        else
          this.banner = false;
        // let x = stringToSplit.split(",");

        //for (this.i = 0; this.i <= data.imagecount - 1; this.i++) {
        //  // var res = str.substring(1, 4);
        //  //this.bannerSlider.fileArray[0]
        //  this.urls.push('/Images/BannerSliderImages/' + data.bannerSliderID + '/' + data.bannerSliderID + '-' + this.i + '-img-' + x[this.i] + '.jpg');
        //  //this.sortValue = document.getElementById("sort-order-" + this.i) as HTMLElement;
        //  //this.sortValue.value(x[this.i]);
        //}

        for (var path of data.bannerSliderImages) {

          this.urls.push(path.imagePath);
          this.serverFile.push(path.imagePath);

        }

        setTimeout(() => {
          for (var path of data.bannerSliderImages) {
            //set sorted value in text box
            this.sortValue = document.getElementById("sort-order-" + this.i) as HTMLElement;
            (this.sortValue).value = path.sortOrder;
            this.url = document.getElementById("url-" + this.i) as HTMLElement;
            (this.url).value = path.url;
            //set id in delete icon
            this.deleteValue = document.getElementById("sort-order-delete-" + this.i) as HTMLElement;
            (this.deleteValue).value = path.id;
            //path.id;
            this.i++;
          }
          // for (this.i = 0; this.i <= data.bannerSliderImages.length - 1; this.i++) {
          // 
          //(<HTMLInputElement>document.getElementById("name")).value = response.name;


          //}
        }, 1000
        );

        //setTimeout(() => {
        //  for (var paths of data.fileArray) {

        //  this.sortValue = document.getElementById("sort-order-" + this.i) as HTMLElement;
        //    
        //    var dd = (paths.split("-")[3]).split();
        //    (this.sortValue).value = paths.split("-")[3]; 
        //    this.i++;
        //  }
        //}, 1000
        //);



        //this.bannerSlider = data;




        // this.selectedBrandImage = this.brandModel.brandLogoImage;
      }
    )
  }
  Getvenders() {

    this.userService.getUsers().subscribe(
      data => {
        this.users = data;
      }
    )
  }
  Getbrands() {

    this.brandService.getBrand().subscribe(
      data => {
        this.brands = data;
      }
    )
  }
  Getcategories() {

    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  ResetValue() {
    this.bannerSlider.brandID = 0;
    this.bannerSlider.categoryID = 0;
    if (this.bannerSlider.sliderFor == 'Brand')
      this.banner = true;
    else
      this.banner = false;
  }
  onSubmit() {
    this.isDisable = false;
    this.count = 0;

    for (this.i = 0; this.i < this.serverFile.length; this.i++) {

      this.sortValue = document.getElementById("sort-order-" + this.i) as HTMLElement;
      this.bannerSlider.BannerSliderImages[this.i].SortOrder = this.sortValue.value.toString();
      this.url = document.getElementById("url-" + this.i) as HTMLElement;
      this.bannerSlider.BannerSliderImages[this.i].url = this.url.value.toString();
      //if (typeof this.bannerSlider.sort != 'undefined')
      //  this.bannerSlider.BannerSliderImages[this.i].SortOrder = this.sortValue.value.toString();
      //else {

      //}

      this.count++;
    }
    this.bannerSliderService.updateBannerSlider(this.bannerSlider).subscribe(
      data => {

        if (data) {
          this.toastr.success('Banner/Slider has been Updated.', 'Success');
          this.bannerSliderID = this.bannerSlider.bannerSliderID;

          if (this.files == 'undefined' || this.files === 0 || this.files == null) {
            setTimeout(() => {
              this.router.navigate(["/BannerSlider-list"]);
            }, 2000);
          }
          else {
            this.upload();
            //if () { this.router.navigate(["/BannerSlider-list"]); }
          }
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Success');
          // this.isSubmitted = false;
          //}
        }

      });
  }
  UploadImages(event) {

    //this.urls = [];
    let files = event;
    this.files = files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        }
        reader.readAsDataURL(file);
      }
    }
  }

  upload() {
    //if (this.files.length === 0)
    //  return;
    
    const formData = new FormData();
    this.count =0;
    for (let file of this.files) {
      if (typeof file.name == 'undefined') {
        formData.append(file, new File([""], "dummy"));
      }
      else {
        formData.append(file.name, file);
      }
      this.sortValue = document.getElementById("sort-order-" + (this.urls.length - 1).toString()) as HTMLElement;
      formData.append("sort-order-" + this.count, this.sortValue.value.toString());

      this.url = document.getElementById("url-" + (this.urls.length - 1).toString()) as HTMLElement;
      formData.append("url-" + this.count, this.url.value.toString());

      this.count++;
    }
    // add BannerSliderID
    formData.append("BannerSliderID", this.bannerSliderID.toString());
    //let headers: HttpHeaders = new HttpHeaders();
    //headers.set("Token", this.cookieService.get('Login'));
    //const uploadReq = new HttpRequest('POST', `api/BannerSlider/UploadFile?userId=` + this.userId +'&banner='+this.banner, formData, {
    //  reportProgress: true,
    //  headers: headers 
    //});


    this.http.post(`api/BannerSlider/UploadFile?userId=` + this.userId + '&banner=' + this.banner, formData, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    }).map((response: Response) => response.json()).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress)
        this.progress = Math.round(100 * event.loaded / event.total);
      else if (event.type === HttpEventType.Response)
        this.message = event.body.toString();
      //this.toastr.success('BannerSlider Added Successfully ', 'Success');
      setTimeout(() => {
        this.router.navigate(["/BannerSlider-list"]);
      }, 2000);
      // this.router.navigate(["/product-list"]);
    });

    //this.http.request(uploadReq).subscribe(event => {
    //  if (event.type === HttpEventType.UploadProgress)
    //    this.progress = Math.round(100 * event.loaded / event.total);
    //  else if (event.type === HttpEventType.Response)
    //    this.message = event.body.toString();
    //  //this.toastr.success('BannerSlider Added Successfully ', 'Success');
    //  setTimeout(() => {
    //    this.router.navigate(["/BannerSlider-list"]);
    //  }, 2000);
    //  // this.router.navigate(["/product-list"]);
    //});
  }
  deleteBannerSlider(id, index,event) {
    
    var file = this.files;
    var events = event;
    var ans = confirm("Are you sure to delete selected image?");
    if (typeof id == 'undefined') {
      this.urls.splice(index, 1);
      //this.files.splice(index, 1);
    }

    else {

      if (ans) {
        //var chek = ;
        if (this.bannerSliderService.deleteBannerSliderImage(id)) {
          this.getBannerSliderById(this._avRoute.snapshot.params["id"]);
        }
        // setTimeout(() =>, 0);
      }
    }

  }
  //upload() {
  //  if (this.files.length === 0)
  //    return;
  //  const formData = new FormData();
  //  for (let file of this.files) formData.append(file.name, file);
  //  // add BannerSliderID
  //  formData.append("BannerSliderID", this.bannerSliderID.toString());
  //  const uploadReq = new HttpRequest('POST', `api/BannerSlider/UploadFile`, formData, {
  //    reportProgress: true,
  //  });
  //  this.http.request(uploadReq).subscribe(event => {
  //    if (event.type === HttpEventType.UploadProgress)
  //      this.progress = Math.round(100 * event.loaded / event.total);
  //    else if (event.type === HttpEventType.Response)
  //      this.message = event.body.toString();
  //    //this.toastr.success('BannerSlider Added Successfully ', 'Success');
  //  setTimeout(() => {
  //    this.router.navigate(["/BannerSlider-list"]);
  //  }, 2000);
  //  });

  //}
  //onSubmit() {
  //  this.categryFields.forEach((element) => {
  //    this.fieldname = "input-" + element.fieldName;
  //    this.inputElement = document.getElementById(this.fieldname) as HTMLElement;
  //    element.value = this.inputElement.value;
  //  });
  //  this.product.Fields = this.categryFields;
  //  this.productService.AddProduct(this.product).subscribe(
  //    data => {
  //      this.productID = data;
  //      this.upload();
  //    });

  //}
  SlectImage(Image: MediaLibrary) {
    // this.fileToUpload = null;
    //this.fd = new FormData();
    this.mediaImageShow = true;
    //this.selectedBrandImage = "";
    // this.brandModel.brandLogoImage = "";
    this.urls.push(Image.folderName + Image.fileName);
    this.files.push(Image.fileName);
    //this.upload();
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    this.modalRef.hide();
  }
  HidePopup() {
    // this.selectedBrandImage = "";
    //this.brandModel.brandLogoImage = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {

        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  removeHome() {
    this.bannerSlider.sliderFor = "";

  }

}



// WEBPACK FOOTER //
// ./src/app/BannerSlider/edit-BannerSlider/edit-BannerSlider.component.ts